import React, { Suspense } from "react";
import { RouterProvider } from "react-router-dom";
import router from "./routes";
import "./App.css";
import Loader from "./components/AnimatedLoader";
// Not rendered (see the commented-out <ChatbotUI /> below) — importing it anyway pulled the whole
// chatbot page into the initial bundle. It's still reachable through its own /agent/chatbot route.
// import ChatbotUI from "./view/agent/chatbot";

import { ToastProvider } from "./contexts/ToastContext";

const App = () => {
  return (
    <ToastProvider>
      {/* Fallback while a code-split top-level page (e.g. /sign-up) is downloading. */}
      <Suspense fallback={<Loader />}>
        <RouterProvider router={router} />
      </Suspense>
      {/* {!hideChatbot && <ChatbotUI />} */}
    </ToastProvider>
  );
};

export default App;
